import { styled } from 'theme'

export const Flex = styled('div', {
  display: 'flex',
  variants: {
    shrink: {
      1: {
        flexShrink: 1,
      },
      0: {
        flexShrink: 0,
      },
    },
    grow: {
      1: {
        flexGrow: 1,
      },
      0: {
        flexGrow: 0,
      },
    },
    direction: {
      row: {
        flexDirection: 'row',
      },
      column: {
        flexDirection: 'column',
      },
      rowReverse: {
        flexDirection: 'row-reverse',
      },
      columnReverse: {
        flexDirection: 'column-reverse',
      },
    },
    align: {
      start: {
        alignItems: 'flex-start',
      },
      center: {
        alignItems: 'center',
      },
      end: {
        alignItems: 'flex-end',
      },
      stretch: {
        alignItems: 'stretch',
      },
      baseline: {
        alignItems: 'baseline',
      },
    },
    justify: {
      start: {
        justifyContent: 'flex-start',
      },
      center: {
        justifyContent: 'center',
      },
      end: {
        justifyContent: 'flex-end',
      },
      between: {
        justifyContent: 'space-between',
      },
    },
    wrap: {
      noWrap: {
        flexWrap: 'nowrap',
      },
      wrap: {
        flexWrap: 'wrap',
      },
      wrapReverse: {
        flexWrap: 'wrap-reverse',
      },
    },
    gap: {
      4: {
        gap: '$space$4',
      },
      6: {
        gap: '$space$6',
      },
      8: {
        gap: '$space$8',
      },
      12: {
        gap: '$space$12',
      },
      16: {
        gap: '$space$16',
      },
      20: {
        gap: '$space$20',
      },
      24: {
        gap: '$space$24',
      },
      30: {
        gap: '$space$30',
      },
      40: {
        gap: '$space$40',
      },
      50: {
        gap: '$space$50',
      },
    },
    gapX: {
      4: {
        columnGap: '$space$4',
      },
      6: {
        columnGap: '$space$6',
      },
      8: {
        columnGap: '$space$8',
      },
      12: {
        columnGap: '$space$12',
      },
      16: {
        columnGap: '$space$16',
      },
      20: {
        columnGap: '$space$20',
      },
      24: {
        gap: '$space$24',
      },
      50: {
        gap: '$space$50',
      },
    },
    gapY: {
      4: {
        rowGap: '$space$4',
      },
      6: {
        rowGap: '$space$6',
      },
      8: {
        rowGap: '$space$8',
      },
      12: {
        rowGap: '$space$12',
      },
      16: {
        rowGap: '$space$16',
      },
      20: {
        rowGap: '$space$20',
      },
      24: {
        gap: '$space$24',
      },
      50: {
        gap: '$space$50',
      },
    },
  },
  defaultVariants: {
    direction: 'row',
    align: 'stretch',
    justify: 'start',
    wrap: 'noWrap',
  },
})

export default Flex
